module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"ThatDarnPat","short_name":"ThatDarnPat","start_url":"/","background_color":"#a640bf","theme_color":"#c76ba8","display":"minimal-ui","icon":"src/images/pat-emoji.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"d08fa1d8b59b4cbad936ae5a24d4e4c3"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
